<template>
    <div class="version1-middle-middle">
        <div class="middle-title">
            <img src="../../../../../static/version1/标题箭头左.png" alt="">
            <span class="text">近十年专利申请量</span>
            <img src="../../../../../static/version1/标题箭头右.png" alt="">
        </div>
        <Bar :options="options" @echartClick="echartClick"></Bar>
    </div>
</template>
<script>
import Bar from '@/components/echarts/Bar'
import { yearRange } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      options: {},
      typeList: [
        {
          name: '发明专利/件',
          label: 'invent',
          data: [],
          value: '发明申请',
          lineStyle: {
            normal: {
              width: 2,
              color: '#EFC600' // 线条颜色
            }
          },
          areaStyle: {
            normal: {
            // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: '#efc600'
                  },
                  {
                    offset: 1,
                    color: 'rgba(255,255,255,0)'
                  }
                ],
                false
              )
            }
          }
        },
        {
          name: '实用新型/件',
          label: 'newKind',
          value: '实用新型',
          data: [],
          lineStyle: {
            normal: {
              width: 2,
              color: '#00F0ED' // 线条颜色
            }
          },
          areaStyle: {
            normal: {
            // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: '#00a6f3'
                  },
                  {
                    offset: 1,
                    color: 'rgba(255,255,255,0)'
                  }
                ],
                false
              )
            }
          }
        },
        {
          name: '外观设计/件',
          label: 'exterior',
          value: '外观设计',
          data: [],
          lineStyle: {
            normal: {
              width: 2,
              color: '#00A6F3' // 线条颜色
            }
          },
          areaStyle: {
            normal: {
            // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: '#01ffff'
                  },
                  {
                    offset: 1,
                    color: 'rgba(255,255,255,0)'
                  }
                ],
                false
              )
            }
          }
        }
      ],
      xData: []
    }
  },
  components: {
    Bar
  },
  mounted() {
    this.getYearRange()
  },
  methods: {
    echartClick(params) {
      let exp = params.data.label
      if (params.data.label === '发明申请') {
        exp = '发明申请 or 发明授权'
      }
      this.jumpIpi(`专利类型=(${exp}) and 申请年=${params.name}`, 'isMerge')
    },
    getYearRange() {
      yearRange().then((res) => {
        //
        if (res[this.codeMapping]) {
          res[this.dataMapping].forEach((item) => {
            if (this.xData.every(items => items !== item.year)) {
              this.xData.push(item.year)
            }
          })
          res[this.dataMapping].forEach((item) => {
            this.typeList.forEach((ele) => {
              if (item.name === ele.label) {
                ele.data.push({value: item.count, label: ele.value})
              }
            })
          })
          this.getChart()
        }
      })
    },
    getChart() {
      const obj = {
        type: 'line',
        // symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
        smooth: true,
        symbolSize: 5

      }
      this.typeList = this.typeList.map(item => {
        return {...obj, ...item}
      })

      this.options = {
        color: ['#EFC600', '#00F0ED', '#00A6F3'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: 'rgb(126,199,255)'
            }
          }
        },
        legend: {

          icon: 'roundRect',
          show: true,
          top: '10%',
          itemWidth: 20, // 图例标记的图形宽度。
          itemHeight: 10, //  图例标记的图形高度。
          itemGap: 30,
          textStyle: {
            color: '#fff',
            fontSize: 14
          }
        },
        grid: {
          top: '30%',
          left: '10%',
          right: '5%',
          bottom: '20%'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              // 坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                width: 2,
                color: '#CBD9DE'
              }
            },
            axisLabel: {
              // 坐标轴刻度标签的相关设置
              textStyle: {
                color: '#CBD9DE',
                fontSize: 12
              }
            },
            axisTick: {
              show: false
            },
            data: this.xData
          }
        ],
        yAxis: [
          {
            // interval: 500,
            name: '',
            nameTextStyle: {
              color: '#fff',
              fontSize: 12,
              padding: [0, 60, 0, 0]
            },
            // minInterval: 1,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'RGBA(51, 71, 85, .8)'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                width: 2,
                color: '#7E8E98'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#CBD9DE',
                fontSize: 14
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: this.typeList
      }
    }
  }
}
</script>
